import React from "react";
// import PropTypes from 'prop-types';

export const Ad = ({
  slot = "8258744308",
  client = "ca-pub-3863319475191168",
  testing = false,
}: {
  slot: string;
  client: string;
  testing: boolean;
}) => (
  <ins
    className="adsbygoogle"
    style={{ display: "block" }}
    data-ad-client={client}
    data-ad-slot={slot}
    data-ad-format="auto"
    data-adtest={testing ? "on" : null}
    data-ad-test={testing ? "on" : null}
  />
);

// export default class Ad extends Component {
//   componentDidMount () {
//     (window.adsbygoogle = window.adsbygoogle || []).push({});
//   }

//   render () {
//     const { slot, client, testing } = this.props;

//     return (
//       <ins
//         className='adsbygoogle'
//         style={{ display: 'block' }}
//         data-ad-client={ client }
//         data-ad-slot={ slot }
//         data-ad-format='auto'
//         data-adtest={ testing ? 'on' : null }
//         data-ad-test={ testing ? 'on' : null }
//       />
//     );
//   }
// }

// Ad.propTypes = {
//   slot: PropTypes.string,
//   client: PropTypes.string,
//   testing: PropTypes.bool
// };

// Ad.defaultProps = {
//   slot: '8258744308',
//   client: 'ca-pub-3863319475191168',
//   testing: false
// };
